import { accordionAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const accordionSlotRecipe = defineSlotRecipe({
  className: 'accordion',
  slots: [...accordionAnatomy.keys(), 'icon', 'secdText', 'suffix', 'suffixBadge'],
  base: {
    item: {
      borderTop: '1px solid',
      borderTopColor: 'border/regular',
    },
    // Zag marks its own parts with data-disabled, but these three are our slots inside the
    // trigger, so nothing lands on them and _disabled would match nothing. They read the state off
    // the ancestor instead — the trigger is a native disabled <button>.
    icon: {
      color: 'icon/secondary',
      '[data-part="item-trigger"]:disabled &': { color: 'icon/disabled' },
    },
    secdText: {
      color: 'text/secondary',
      textStyle: 'body/lg/regular',
      '[data-part="item-trigger"]:disabled &': { color: 'text/disabled' },
    },
    suffix: {
      color: 'text/secondary',
      marginInline: '16',
      textStyle: 'body/md/regular',
      '[data-part="item-trigger"]:disabled &': { color: 'text/disabled' },
    },
    // Spacing only — the badge brings its own colours.
    suffixBadge: {
      marginInline: '16',
    },
    itemContent: {
      _open: {
        animationName: 'expand-height, fade-in',
        animationDuration: 'moderate',
      },
      _closed: {
        animationName: 'collapse-height, fade-out',
        animationDuration: 'moderate',
      },
      _motionReduce: {
        animationName: 'none',
      },
      overflow: 'hidden',
    },
    itemBody: {
      paddingX: '16',
      paddingTop: '8',
      paddingBottom: '24',
      _disabled: {
        color: 'text/disabled',
      },
    },
    itemIndicator: {
      display: 'flex',
      color: 'icon/secondary',
      _disabled: {
        color: 'icon/disabled',
      },
    },
    itemTrigger: {
      textAlign: 'start',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      flexDirection: 'row',
      padding: '16',
      gap: '16',
      cursor: 'pointer',
      _open: {
        textStyle: 'body/lg/semibold',
      },
      // The pressed background also has to be nested inside _hover. `_hover` compiles to a
      // `@media (hover: hover)` block, which Chakra emits after the plain-selector rules, so a
      // top-level `_active` of equal specificity always loses to it — and a pointer press is a
      // hover too, which made the pressed state unreachable with a mouse.
      _hover: {
        background: 'background/hover',
        _active: {
          background: 'background/active',
        },
      },
      _active: {
        background: 'background/active',
      },
      _disabled: {
        color: 'text/disabled',
        cursor: 'not-allowed',
      },
    },
    root: {
      borderBottom: '1px solid',
      borderBottomColor: 'border/regular',
    },
  },
});

export default accordionSlotRecipe;
